interface AppConfig {
    instrumentationKey?: string;
  }
  
  export const appConfig: AppConfig = {
    instrumentationKey: process.env.REACT_APP_APPINSIGHTS_INSTRUMENTATIONKEY,
  };
  